/* eslint-disable import/no-default-export */
import HeartWrapper from './Heart/HeartWrapper.jsx';

export { HeartWrapper };
export default HeartWrapper;
